import * as React from "react";

import { EntitetModellComponent} from "../Component/EntitetModellComponent"
import { side } from "../Component/components"
import { appContext } from "../App/appContext"
import { alleHandlinger } from "../Component/Handlinger"
import { LinkButton } from "../Component/LinkButton"
import { feltFormattert, join, visSomPdf, hentFeltVerdi, finnFelt, inlineFelt, errors } from "../Component/felt";
import { ILoaderProps, IModelHandler } from "../domene"

import Models = Gf.Web.Models;

function heading() {
    return <tr>
               <td className="celle kolonne pre bold">
                   <table><tbody>
                       <tr><td className="leftNumber">1.</td><td>Grenseforsikring for motorkjøretøy</td></tr>
                       <tr>
                           <td>1.</td>
                           <td>
                               LIABILITY INSURANCE FOR MOTOR VEHICLES
                               <br />
                               International Motor Insurance Card for Frontier Insurance
                           </td>
                       </tr>
                       <tr><td>1.</td><td>Carte Internationale d&#39;Assurance Automobile</td></tr>
                       </tbody></table>
               </td>
               <td className="celle kolonne bold">
                   <table><tbody>
                       <tr><td className="leftNumber">2.</td><td>TRAFIKKFORSIKRINGSFORENINGEN
                           <br />
                           Norwegian Motor Insurers&#39; Bureau
                           <br />
                           P.O. Box 2551 Solli
                           <br />
                           N-0202 Oslo
                       </td></tr>
                       </tbody></table>
               </td>
           </tr>;
};

function poliseInnhold(model: Models.PoliseModell | undefined, handler: IModelHandler<Models.PoliseFeltType>, clientAction: (handling: Models.HandlingType) => boolean) {
      const pdf = (appContext.visning === "pdf");
      const poliseFelt = (feltType: Models.PoliseFeltType, ingenVerdiTekst?: string) => inlineFelt(model, handler, feltType, ingenVerdiTekst);
      const test = appContext.testServer;
      const poliseStatus = hentFeltVerdi(finnFelt(model, Models.PoliseFeltType.PoliseStatus));
      const makulert = poliseStatus === "Makulert";
      const kladd = poliseStatus === "Kladd";
      const forlengelseAvPoliseNr = hentFeltVerdi(finnFelt(model, Models.PoliseFeltType.ForlengerPoliseNr)) as number | undefined;
      const forlengelseAvPoliseId = hentFeltVerdi(finnFelt(model, Models.PoliseFeltType.ForlengerPoliseId)) as number | undefined;
      const forlengelseInfo = forlengelseAvPoliseNr ? <span className="forlengelseInfo">(Dette er en forlengelse av polise <LinkButton to={`/Polise/${forlengelseAvPoliseId}`}>{forlengelseAvPoliseNr}</LinkButton>)</span> : null;
      return <div><div className="polise">
            { makulert ? <div className="diagonalYtre"><div className="diagonalIndre">MAKULERT</div></div> : null }
            { alleHandlinger(model, handler, clientAction) }
                {errors(handler)}
                <table className="tabell">
                    <tbody>
                        {heading()}
                        <tr>
                            <td className="celle">
                                    <table><tbody>
                                    <tr><td className="leftNumber"><b>3.</b></td><td>Gyldig (begge datoer inkludert) / Valid (both dates inclusive)</td></tr>
                                    </tbody></table>
                                <table className="fraTilTabell"><tbody>
                                    <tr>
                                        <td className="width50 celle-right">Fra/From <span className="fraTilFelt">{poliseFelt(Models.PoliseFeltType.VarighetFraDato) }</span></td>
                                        <td className="width50">Til/To <span className="fraTilFelt">{poliseFelt(Models.PoliseFeltType.VarighetMåneder) }</span></td>
                                    </tr>
                                </tbody></table>
                            </td>
                            <td className="celle" rowSpan={2}>
                                    <table><tbody>
                                        <tr>
                                            <td className="leftNumber"><b>4.</b></td>
                                            <td>
                                                <div className="norsk">Landkode/Forsikringskode/Number</div>
                                                <div className="engelsk">Country code/Insurer&#39;s Code/Number</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                             <td>
                                        <b>N / 01 / </b><span className="poliseNummer">
                                                    {poliseFelt(Models.PoliseFeltType.PoliseNr, "Tildel automatisk")}
                                                    {makulert ? <div className="makulert">MAKULERT</div> : null}
                                                    {test 
                                                        ? <div className="ikkeGyldig">TEST / IKKE GYLDIG / NOT VALID</div> 
                                                        : (kladd 
                                                            ? <div className="ikkeGyldig">IKKE GYLDIG / NOT VALID</div>
                                                            : null)}
                                                 </span>
                                            </td>
                                        </tr>
                                    </tbody></table>
                            </td>
                        </tr>
                        <tr>
                            <td className="datoTabellCelle">
                                <table className="datoTabell"><tbody>
                                    <tr>
                                        <td className="datoHeading padding">
                                            <span className="datePartLabel">Day</span>
                                            <span className="datePart">{feltFormattert(model, Models.PoliseFeltType.VarighetFraDato, handler.laster, "DD") }</span>
                                        </td>
                                        <td className="datoHeading padding">
                                            <span className="datePartLabel">Month</span>
                                            <span className="datePart">{feltFormattert(model, Models.PoliseFeltType.VarighetFraDato, handler.laster, "MM") }</span>
                                        </td>
                                        <td className="datoHeading padding">
                                            <span className="datePartLabel">Year</span>
                                            <span className="datePart">{feltFormattert(model, Models.PoliseFeltType.VarighetFraDato, handler.laster, "YYYY") }</span>
                                        </td>
                                        <td className="datoHeading padding">
                                            <span className="datePartLabel">Day</span>
                                            <span className="datePart">{feltFormattert(model, Models.PoliseFeltType.VarighetTilDato, handler.laster, "DD") }</span>
                                        </td>
                                        <td className="datoHeading padding">
                                            <span className="datePartLabel">Month</span>
                                            <span className="datePart">{feltFormattert(model, Models.PoliseFeltType.VarighetTilDato, handler.laster, "MM")}</span>
                                        </td>
                                        <td className="datoHeading padding">
                                            <span className="datePartLabel">Year</span>
                                            <span className="datePart">{feltFormattert(model, Models.PoliseFeltType.VarighetTilDato, handler.laster, "YYYY") }</span>
                                        </td>
                                    </tr>
                                </tbody></table>
                            </td>
                        </tr>
                        <tr>
                            <td rowSpan={2} className="celle">
                                <table className="width100"><tbody>
                                    <tr>
                                        <td className="leftNumber"><b>5.</b></td>
                                        <td>Motorvogn/Vehicle</td>
                                    </tr>
                                    <tr>
                                        <td className="leftNumber"><b>a.</b></td>
                                        <td>Land / Country: {poliseFelt(Models.PoliseFeltType.Kjøretøyland) }</td>
                                    </tr>
                                    <tr>
                                        <td className="leftNumber"><b>b.</b></td>
                                        <td>Kjennetegn / License plate: {poliseFelt(Models.PoliseFeltType.Kjennetegn) }</td>
                                    </tr>
                                    <tr>
                                        <td className="leftNumber"><b>c.</b></td>
                                        <td>Chassisnummer / Chassis number: {poliseFelt(Models.PoliseFeltType.Chassisnummer) }</td>
                                    </tr>
                                </tbody></table>
                            </td>
                            <td className="celle">
                                <table className="width100"><tbody>
                                    <tr>
                                        <td className="leftNumber"><b>6.</b></td>
                                        <td>Motorvognens kategori / Category of Vehicle
                                            {poliseFelt(Models.PoliseFeltType.Kjøretøyklasse) }</td>
                                    </tr>
                                </tbody></table>
                            </td>
                        </tr>
                        <tr>
                            <td className="celle">
                                <table className="width100"><tbody>
                                    <tr>
                                        <td className="leftNumber"><b>7.</b></td>
                                        <td>Motorvognens merke og modell / Make and Model of Vehicle
                                            {poliseFelt(Models.PoliseFeltType.Merke) }</td>
                                    </tr>
                                </tbody></table>

                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2} className="celle">
                                Betalt premie/Premium paid (NOK)
                                            {poliseFelt(Models.PoliseFeltType.Pris) }{forlengelseInfo}</td>
                        </tr>
                        {pdf ?
                        <tr>
                            <td colSpan={2} className="celle kjedelig">
                                <table><tbody>
                                    <tr>
                                        <td className="leftNumber"><b>8.</b></td>
                                        <td>Gyldighetsområde/Territoral validity
                                    Dette kortet er gyldig i alle land innenfor EØS og Sveits.
                                    &nbsp; <span className="footnote">1)</span> Dekningen
                                            for Kypros del bare for
                                    de geografiske områder som er under kontroll av
                                    regjeringen for republikken Kypros.
                                    </td></tr>
                                    <tr><td></td><td>
                                    This insurance is valid in all states of the EEC and
                                        Switzerland. &nbsp; <span className="footnote">1)</span> The
                                        cover provided from Cyprus is
                                    restricted to those geographical parts of
                                    Cyprus which are under the control of the
                                    Government of the Republic of Cyprus.
                                    </td></tr>
                                    <tr><td></td><td>
                                    I hvert land som blir besøkt, og hvor dette kortet
                                    er gyldig, vil byrået i vedkommende land (se kortets
                                    bakside) garantere forsikringsdekningen med hensyn
                                    til bruken av den motorvogn som er nevnt i dette
                                    forsikringskortet, overensstemmende med de lover om
                                    obligatorisk motorvognforsikring som er gitt
                                    i landet.
                                    </td></tr>
                                    <tr><td></td><td>
                                    In each country visited, the Bureau of that country
                                    guarantees, in respect of the use of the vehicle
                                    referred to herein, the insurance cover accordance
                                    with the laws relating to compulsory insurance in
                                    that country.
                                    </td></tr>
                                    <tr><td></td><td>
                                    For informasjon om relevant byrå se baksiden. For
                                    ytterligere informasjon se
                                    www.cobx.org.
                                    </td></tr>
                                    <tr><td></td><td>
                                    For the identification of the relevant Bureau, see
                                    reversible side. For further information, please
                                    see www.cobx.org.
                                    </td></tr>
                                </tbody>
                                </table>
                            </td>
                        </tr>
                        : null}
                        {pdf ?
                           <tr>
                                <td colSpan={2} className="celle nopad kjedelig">
                                <table className="landTabell"><tbody>
                                    <tr>
                                        <td className="landCelle">A</td>
                                        <td className="landCelle">B</td>
                                        <td className="landCelle">BG</td>
                                        <td className="landCelle">CY <span className="footnote">1)</span></td>
                                        <td className="landCelle">CZ</td>
                                        <td className="landCelle">D</td>
                                        <td className="landCelle">DK</td>
                                        <td className="landCelle">E</td>
                                        <td className="landCelle">EST</td>
                                        <td className="landCelle">F</td>
                                        <td className="landCelle">FIN</td>
                                        <td className="landCelle">GB</td>
                                        <td className="landCelle">GR</td>
                                        <td className="landCelle">H</td>
                                        <td className="landCelle">I</td>
                                    </tr>
                                    <tr>
                                        <td className="landCelle">IRL</td>
                                        <td className="landCelle">IS</td>
                                        <td className="landCelle">L</td>
                                        <td className="landCelle">LT</td>
                                        <td className="landCelle">LV</td>
                                        <td className="landCelle">M</td>
                                        <td className="landCelle">N</td>
                                        <td className="landCelle">NL</td>
                                        <td className="landCelle">P</td>
                                        <td className="landCelle">PL</td>
                                        <td className="landCelle">RO</td>
                                        <td className="landCelle">S</td>
                                        <td className="landCelle">SK</td>
                                        <td className="landCelle">SLO</td>
                                        <td className="landCelle">CH</td>
                                    </tr>
                                </tbody></table>
                            </td>
                            </tr>
                        :null}
                        {pdf ?
                            <tr>
                                <td colSpan={2} className="celle enlinje">
                                    Forsikringstagers eller brukers navn og adresse
                                    / Name and address of the Policyholder
                                <div className="litenAvstand" />
                                {formatterAdresse(poliseFelt)}
                                </td>
                            </tr>
                            :
                        <tr>
                          <td className="celle">
                                <table className="width100"><tbody>

                                    <tr>
                                        <td>Forsikringstager / Policyholder</td>
                                    </tr>
                                    <tr>
                                        <td> {poliseFelt(Models.PoliseFeltType.ForsikringstakerNavn) }</td>
                                     </tr>
                                         <tr>
                                        <td>Mobil / Mobile</td>
                                    </tr>
                                    <tr>
                                        <td> {poliseFelt(Models.PoliseFeltType.ForsikringstakerMobil) }</td>
                                     </tr>
                                         <tr>
                                        <td>E-post / E-mail</td>
                                    </tr>
                                    <tr>
                                        <td> {poliseFelt(Models.PoliseFeltType.ForsikringstakerEpost) }</td>
                                     </tr>
                                     <tr>
                                         <td></td>
                                      </tr>
                                      <tr>
                                          <td></td>
                                       </tr>
                                        </tbody>
                                   </table>
                            </td>
                             <td className="celle">
                                <table className="width100"><tbody>
                                        <tr>
                                            <td>Adresse / Address</td>
                                        </tr>
                                        <tr>
                                            <td> {poliseFelt(Models.PoliseFeltType.ForsikringstakerGateadresse) }</td>
                                        </tr>
                                        <tr>
                                            <td>Postnummer / Postal code</td>
                                        </tr>
                                        <tr>
                                            <td> {poliseFelt(Models.PoliseFeltType.ForsikringstakerPostnummer) }</td>
                                        </tr>
                                        <tr>
                                            <td>Poststed / City</td>
                                        </tr>
                                        <tr>
                                            <td> {poliseFelt(Models.PoliseFeltType.ForsikringstakerPoststed) }</td>
                                        </tr>
                                        <tr>
                                            <td>Land / Country</td>
                                        </tr>
                                        <tr>
                                            <td> {poliseFelt(Models.PoliseFeltType.ForsikringstakerLand) }</td>
                                        </tr>
                                        </tbody>
                                   </table>
                            </td>
                        </tr>
                        }
                        <tr>
                            <td className="celle">
                                Utsteder/risikobærer
                                <br />
                                Underwriter
                                <br/>
                                <br/>
                                <b>
                                TRAFIKKFORSIKRINGSFORENINGEN
                                <br/>
                                Postboks 2551 Solli
                                <br/>
                                NO-0202 OSLO
                                </b>
                            </td>
                            <td className="celle">
                                Dette kortet er utstedt av
                                    <br />
                                    This card has been issued by
                                    <br/>
                                    <div className="litenAvstand"/>
                                    {poliseFelt(Models.PoliseFeltType.UtstederRegion) }
                                    <div className={`mindreTekst${pdf ? " hidden" : ""}`}>{poliseFelt(Models.PoliseFeltType.UtstederPerson)}</div>
                                    <div className="litenAvstand" />
                                    <div className="mindreTekst">{poliseFelt(Models.PoliseFeltType.UtstedtDato) }</div>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2} className="celle">
                                    Jeg har mottatt informasjon vedrørende denne
                                    forsikringen / I have received information concerning
                                    this insurance
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    ............................................................................................
                                    <br/>
                                    (signatur/signature)
                            </td>
                        </tr>
                    </tbody></table>

                <div className="nyttigInformasjon kjedelig">
                    Nyttig informasjon:
                    <br />
                    <br />
                    Forsikringstager gir herved Traffikkforsikringsforeningen, og
                    andre lands byråer- som det måtte delegere sin myndighet til, -
                    fullmakt til å representere meg i rettsaker. De kan på mine
                    vegne avgjøre et hvert krav om erstatning for de skader på tredjemann
                    som må dekkes i henhold til lover om obligatorisk forsikring,
                    i det eller de land som er angitt i dette forsikringskortet, og
                    som måtte oppstå som følge av bruken av motorvognen i dette
                    (disse) land.
                    <br />
                    <br />
                    I, the within-mentioned insured hereby authorise
                    Trafikkforsikringsforeningen as well as the bureaux of any
                    mentioned countries, to which they may delegate such powers,
                    to accept service of legal proceedings, to handle and
                    eventually settle, on my behalf, any claim for damages in
                    respect of liability to third parties required to be covered
                    under the compulsory motor legislation of the country specified
                    herein, which may arise from the use of the vehicle in that country
                    (those countries).
                </div>
            </div>
            <img className="bakside" src="/Content/polise_bakside.png" />
        </div>;
    }

function formatterAdresse(poliseFelt: (feltType: Models.PoliseFeltType) => JSX.Element | null) {
    const komma = <span className="komma">, </span>;
    const mellomrom = <span className="mellomrom"> </span>;
    return join(komma,
    [
        poliseFelt(Models.PoliseFeltType.ForsikringstakerNavn),
        poliseFelt(Models.PoliseFeltType.ForsikringstakerGateadresse),
        join(mellomrom, [
            poliseFelt(Models.PoliseFeltType.ForsikringstakerPostnummer),
            poliseFelt(Models.PoliseFeltType.ForsikringstakerPoststed)
        ]),
        poliseFelt(Models.PoliseFeltType.ForsikringstakerLand)
    ]);
}

export class Polise extends EntitetModellComponent<Models.PoliseFeltType, Models.PoliseModell> {
    constructor(props: ILoaderProps) {
        super(props, "Polise"); 
    }

    clientAction(handling: Models.HandlingType) {
        if (handling === Models.HandlingType.Polise_Pdf) {
            visSomPdf();
            return true;
        }
        return false;
    }

    renderWithModel(model: Models.PoliseModell | undefined) {
        
        const poliseNr = feltFormattert(model, Models.PoliseFeltType.PoliseNr, this.getHandler().laster);

        return side(`Polise ${poliseNr || " (ikke utstedt)"}`,
            poliseInnhold(model,
            this.getHandler(),
            handling => this.clientAction(handling)));
    }
}



// WEBPACK FOOTER //
// ./Scripts/React/Polise/Polise.tsx